import React, {useEffect, useState} from "react";
import {Route, Switch, Redirect, useLocation, Link} from "react-router-dom";
//locall
import {storage} from "../utils";
import {useAppContext} from "../context/state";
// routes
import {Home} from "./home/Home";
import {Analytics} from "./analytics/Analytics";
import {SignIn} from "./signIn/SignIn";
import {AddProduct} from "./addProduct/AddProduct";
import {ShowProducts} from "./showProducts/ShowProducts";
import { AddBlogPost } from "./addBlogPost/AddBlogPost";
import { GetBlogPosts } from "./getBlogPosts/GetBlogPosts";
import { EditBlogPost } from "./editBlogPost/EditBlogPost";
import { ManageBlogCategories } from "./manageBlogCategories/ManageBlogCategories";
//styles
import "../assets/vendors/css/vendors.min.css";
import "../assets/vendors/css/charts/apexcharts.css";
import "../assets/vendors/css/extensions/swiper.min.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/bootstrap-extended.css";
import "../assets/css/colors.css";
import "../assets/css/components.css";
import "../assets/css/themes/dark-layout.css";
import "../assets/css/themes/semi-dark-layout.css";
import "../assets/css/core/menu/menu-types/vertical-menu.css";
import "../assets/css/pages/dashboard-ecommerce.css";
import "../assets/vendors/css/tables/datatable/datatables.min.css";
import "../assets/css/plugins/forms/wizard.css";
import "../assets/vendors/css/charts/apexcharts.css";
import "../assets/vendors/css/extensions/dragula.min.css";
import "../assets/css/pages/dashboard-analytics.css";
import {ShowComments} from "./comments/ShowComments";
import {CommentDetails} from "./commentDetails/CommentDetails";
import {GetTerms} from "./getTerms/GetTerms";
import {AddTerm} from "./addTerm/AddTerm";
import {GetDays} from "./getDays/GetDays";
import {GetFiles} from "./getFiles/GetFiles";
import {AddFile} from "./addFile/AddFile";
import {GetProductFiles} from "./getProductFiles/GetProductFiles";
import {AddProductFile} from "./addProductFile/AddProductFile";
import {EditProduct} from "./editProduct/EditProduct";
import {EditFile} from "./editFile/EditFile";
import {GetUsers} from "./getUsers/GetUsers";
import {GetPayments} from "./getPayments/GetPayments";
import {Menu} from "./menu/Menu";
import {AddTopMenu} from "./addTopMenu/AddTopMenu";
import {AddBottomMenu} from "./addBottomMenu/addBottomMenu";
import {UpdateInformation} from "./updateInformation/UpdateInformation";
import {GetAdminUsers} from "./getAdminUsers/GetAdminUsers";
import {AddDashboardUser} from "./addDashboardUser/AddDashboardUser";
import {PaymentDetails} from "./paymentDetails/PaymentDetails";
import {UserDetails} from "./userDetails/UserDetails";
import {AddProductToUser} from "./addProductToUser/AddProductToUser";
import {EditProductToUser} from "./editProductToUser.js/EditProductToUser";
import {GetContactUS} from "./getContactUS/getContactUS";
import {ContactUSDetails} from "./contactUSDetails/ContactUSDetails";
import {GetLeads} from "./getLeads/getLeads";
import {ConsultationLeads} from "./consultationLeads/ConsultationLeads";
import {EditTerm} from "./editTerm/EditTerm";
import {AddPaymentToUser} from "./AddPaymentToUser/AddPaymentToUser";
import {PaymentsProductToUser} from "./paymentsProductToUser/PaymentsProductToUser";
import {GetUserProducts} from "./getUserProducts/GetUserProducts";
import {GetSupportPayments} from "./getSupportPayments/GetSupportPayments";
import {editProfile} from "./editProfile/editProfile";
import {AddDiscountCode} from "./addDiscountCode/AddDiscountCode";
import {GetDiscountCodes} from "./getDiscountCodes/GetDiscountCodes";
import {ForumCategories} from "./forumCategories/ForumCategories";
import {addForumCategory} from "./addForumCategory/addForumCategory";
import {AddSpecialOffers} from "./addSpecialOffer/addSpecialOffer";
import {EditLive} from "./editLive/EditLive";
import {ManageHomepageFeatured} from "./manageHomepageFeatured/ManageHomepageFeatured";
import {ManageSiteSections} from "./manageSiteSections/ManageSiteSections";
import {EditProductFile} from "./editProductFile/EditProductFile";
import {AddNotification} from "./addNotification/addNotification";
import {addClientUser} from "./addClientUser/AddDashboardUser";

const PrivateRoute = ({component: Component, children, ...rest}) => {
    const [isTokenAvailable, setToken] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        storage
            .load("token")
            .then((res) => {
                if (!res) return Promise.reject();
                setToken(true);
                setLoading(false);
            })
            .catch(() => {
                setToken(false);
                setLoading(false);
            });
    }, []);
    return loading ? null : (
        <Route
            {...rest}
            render={(props) =>
                isTokenAvailable ? (
                    <>
                        <Component {...props} />
                    </>
                ) : (
                    <Redirect to="/signIn"/>
                )
            }
        >
            {children}
        </Route>
    );
};

const PrivateRoutes = ({match}) => {
    return (
        <>
            <Switch>
                <Route path={match.url} exact={true} component={Home}></Route>
                <Route path={match.url + "/analytics"} exact={true} component={Analytics}/>
                <Route
                    path={match.url + "/addProduct"}
                    exact={true}
                    component={AddProduct}
                />
                <Route
                    path={match.url + "/editProduct/:id"}
                    exact={true}
                    component={EditProduct}
                />
                <Route
                    path={match.url + "/showProducts"}
                    exact={true}
                    component={ShowProducts}
                />
                <Route
                    path={match.url + "/addTerm/:id"}
                    exact={true}
                    component={AddTerm}
                />
                <Route
                    path={match.url + "/editTerm/:term_id/term/:product_id"}
                    exact={true}
                    component={EditTerm}
                />
                <Route
                    path={match.url + "/terms/:id"}
                    exact={true}
                    component={GetTerms}
                />
                <Route
                    path={match.url + "/addFile/:id"}
                    exact={true}
                    component={AddProductFile}
                />
                <Route
                    path={match.url + "/addSpecialOffer"}
                    exact={true}
                    component={AddSpecialOffers}
                />
                <Route
                    path={match.url + "/addNotification"}
                    exact={true}
                    component={AddNotification}
                />
                <Route
                    path={match.url + "/files/:id"}
                    exact={true}
                    component={GetProductFiles}
                />
                <Route
                    path={match.url + "/days/:term_id/terms/:product_id"}
                    exact={true}
                    component={GetDays}
                />
                <Route
                    path={match.url + "/files/:day_id/days/:term_id/terms/:product_id"}
                    exact={true}
                    component={GetFiles}
                />
                <Route
                    path={match.url + "/files/editProductFile/:product_id"}
                    exact={true}
                    component={EditProductFile}
                />

                <Route
                    path={match.url + "/addFile/:day_id/days/:term_id/terms/:product_id"}
                    exact={true}
                    component={AddFile}
                />
                <Route
                    path={match.url + "/editFile/:day_id/days/:term_id/terms/:product_id"}
                    exact={true}
                    component={EditFile}
                />
                <Route
                    path={match.url + "/showForumCategories"}
                    exact={true}
                    component={ForumCategories}
                />
                <Route
                    path={match.url + "/addForumCategory"}
                    exact={true}
                    component={addForumCategory}
                />
                <Route
                    path={match.url + "/showComments"}
                    exact={true}
                    component={ShowComments}
                />
                <Route
                    path={match.url + "/commentDetails/:id"}
                    exact={true}
                    component={CommentDetails}
                />
                <Route
                    path={match.url + "/getUsers"}
                    exact={true}
                    component={GetUsers}
                />
                <Route
                    path={match.url + "/getUserProducts"}
                    exact={true}
                    component={GetUserProducts}
                />
                <Route
                    path={match.url + "/getPayments"}
                    exact={true}
                    component={GetPayments}
                />
                <Route
                    path={match.url + "/editLive"}
                    exact={true}
                    component={EditLive}
                />
                <Route
                    path={match.url + "/homepageFeatured"}
                    exact={true}
                    component={ManageHomepageFeatured}
                />
                <Route
                    path={match.url + "/getSupportPayments"}
                    exact={true}
                    component={GetSupportPayments}
                />
                <Route path={match.url + "/menu"} exact={true} component={Menu}/>
                <Route path={match.url + "/siteSections"} exact={true} component={ManageSiteSections}/>
                <Route
                    path={match.url + "/addTopMenu"}
                    exact={true}
                    component={AddTopMenu}
                />
                <Route
                    path={match.url + "/addBottomMenu"}
                    exact={true}
                    component={AddBottomMenu}
                />
                <Route
                    path={match.url + "/updateInformation"}
                    exact={true}
                    component={UpdateInformation}
                />
                <Route
                    path={match.url + "/getAdminUsers"}
                    exact={true}
                    component={GetAdminUsers}
                />
                <Route
                    path={match.url + "/addDashboardUser"}
                    exact={true}
                    component={AddDashboardUser}
                />
                <Route
                    path={match.url + "/addClientUser"}
                    exact={true}
                    component={addClientUser}
                />
                <Route
                    path={match.url + "/paymentDetails/:id"}
                    exact={true}
                    component={PaymentDetails}
                />
                <Route
                    path={match.url + "/userDetails/:id"}
                    exact={true}
                    component={UserDetails}
                />
                <Route
                    path={
                        match.url +
                        "/userDetails/:user_id/paymentsProductToUser/:product_id"
                    }
                    exact={true}
                    component={PaymentsProductToUser}
                />
                <Route
                    path={match.url + "/userDetails/:id/addProductToUser"}
                    exact={true}
                    component={AddProductToUser}
                />
                <Route
                    path={match.url + "/userDetails/:id/addPaymentToUser"}
                    exact={true}
                    component={AddPaymentToUser}
                />
                <Route
                    path={
                        match.url + "/userDetails/:user_id/editProductToUser/:product_id"
                    }
                    exact={true}
                    component={EditProductToUser}
                />
                <Route
                    path={match.url + "/getContactUS"}
                    exact={true}
                    component={GetContactUS}
                />
                <Route
                    path={match.url + "/contactUSDetails/:id"}
                    exact={true}
                    component={ContactUSDetails}
                />
                <Route
                    path={match.url + "/getLeads"}
                    exact={true}
                    component={GetLeads}
                />
                <Route path={match.url + "/consultationLeads"} exact={true} component={ConsultationLeads}/>
                <Route
                    path={match.url + "/editProfile"}
                    exact={true}
                    component={editProfile}
                />
                <Route
                    path={match.url + "/addDiscountCode"}
                    exact={true}
                    component={AddDiscountCode}
                />
                <Route path={match.url + "/getDiscountCodes"} exact={true} component={GetDiscountCodes} />
                <Route path={match.url + "/editDiscountCode/:id"} exact={true} component={AddDiscountCode} />
                <Route
                    path={match.url + "/addBlogPost"}
                    exact={true}
                    component={AddBlogPost}
                />
                <Route
                    path={match.url + "/getBlogPosts"}
                    exact={true}
                    component={GetBlogPosts}
                />
                <Route
                  path={match.url + "/editBlog/:id"}
                  exact={true}
                  component={EditBlogPost}
                />
                <Route
                  path={match.url + "/blogCategories"}
                  exact={true}
                  component={ManageBlogCategories}
                />
            </Switch>
        </>
    );
};

const Screens = () => {
    const {user} = useAppContext();
    const location = useLocation();
    const pathname = location.pathname;
    const isDashboardActive = pathname === "/dashboard";
    const isAnalyticsActive = pathname === "/dashboard/analytics";

    console.log(user)

    return (
        <>
            {/* <!-- BEGIN: Header--> */}
            <Route path="/signIn" component={SignIn}/>
            <div class="header-navbar-shadow"></div>
            <nav class="header-navbar main-header-navbar navbar-expand-lg navbar navbar-with-menu fixed-top ">
                <div class="navbar-wrapper">
                    <div class="navbar-container content">
                        <div class="navbar-collapse" id="navbar-mobile">
                            <div class="mr-auto float-left bookmark-wrapper d-flex align-items-center">
                                <ul class="nav navbar-nav">
                                    <li class="nav-item mobile-menu d-xl-none mr-auto">
                                        <a
                                            class="nav-link nav-menu-main menu-toggle hidden-xs"
                                            href="#"
                                        >
                                            <i class="ficon bx bx-menu"></i>
                                        </a>
                                    </li>
                                </ul>
                                {/* <ul class="nav navbar-nav bookmark-icons">
                  <li class="nav-item d-none d-lg-block">
                    <a
                      class="nav-link"
                      href="app-email.html"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="ایمیل"
                    >
                      <i class="ficon bx bx-envelope"></i>
                    </a>
                  </li>
                  <li class="nav-item d-none d-lg-block">
                    <a
                      class="nav-link"
                      href="app-chat.html"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="گفتگو"
                    >
                      <i class="ficon bx bx-chat"></i>
                    </a>
                  </li>
                  <li class="nav-item d-none d-lg-block">
                    <a
                      class="nav-link"
                      href="app-todo.html"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="وظایف"
                    >
                      <i class="ficon bx bx-check-circle"></i>
                    </a>
                  </li>
                  <li class="nav-item d-none d-lg-block">
                    <a
                      class="nav-link"
                      href="app-calendar.html"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="تقویم"
                    >
                      <i class="ficon bx bx-calendar-alt"></i>
                    </a>
                  </li>
                </ul> */}
                                {/* <ul class="nav navbar-nav">
                  <li class="nav-item d-none d-lg-block">
                    <a class="nav-link bookmark-star">
                      <i class="ficon bx bx-star warning"></i>
                    </a>
                    <div class="bookmark-input search-input">
                      <div class="bookmark-input-icon">
                        <i class="bx bx-search primary"></i>
                      </div>
                      <input
                        class="form-control input"
                        type="text"
                        placeholder="جستجو ..."
                        tabindex="0"
                        data-search="template-search"
                      />
                      <ul class="search-list"></ul>
                    </div>
                  </li>
                </ul> */}
                            </div>
                            <ul class="nav navbar-nav float-right">
                                {/* <li class="dropdown dropdown-language nav-item">
                  <a
                    class="dropdown-toggle nav-link"
                    id="dropdown-flag"
                    href="#"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="flag-icon flag-icon-ir"></i>
                    <span class="selected-language">فارسی</span>
                  </a>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdown-flag"
                  >
                    <a class="dropdown-item" href="#" data-language="fa">
                      <i class="flag-icon flag-icon-ir mr-50"></i> فارسی
                    </a>
                    <a class="dropdown-item" href="#" data-language="en">
                      <i class="flag-icon flag-icon-us mr-50"></i> انگلیسی
                    </a>
                    <a class="dropdown-item" href="#" data-language="fr">
                      <i class="flag-icon flag-icon-fr mr-50"></i> فرانسوی
                    </a>
                    <a class="dropdown-item" href="#" data-language="de">
                      <i class="flag-icon flag-icon-de mr-50"></i> آلمانی
                    </a>
                    <a class="dropdown-item" href="#" data-language="pt">
                      <i class="flag-icon flag-icon-pt mr-50"></i> پرتغالی
                    </a>
                  </div>
                </li>
                <li class="nav-item d-none d-lg-block">
                  <a class="nav-link nav-link-expand">
                    <i class="ficon bx bx-fullscreen"></i>
                  </a>
                </li>
                <li class="nav-item nav-search">
                  <a class="nav-link nav-link-search">
                    <i class="ficon bx bx-search"></i>
                  </a>
                  <div class="search-input">
                    <div class="search-input-icon">
                      <i class="bx bx-search primary"></i>
                    </div>
                    <input
                      class="input"
                      type="text"
                      placeholder="جستجو ..."
                      tabindex="-1"
                      data-search="template-search"
                    />
                    <div class="search-input-close">
                      <i class="bx bx-x"></i>
                    </div>
                    <ul class="search-list"></ul>
                  </div>
                </li>
                <li class="dropdown dropdown-notification nav-item">
                  <a
                    class="nav-link nav-link-label"
                    href="#"
                    data-toggle="dropdown"
                  >
                    <i class="ficon bx bx-bell bx-tada bx-flip-horizontal"></i>
                    <span class="badge badge-pill badge-danger badge-up">
                      5
                    </span>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-media">
                    <li class="dropdown-menu-header">
                      <div class="dropdown-header px-1 py-75 d-flex justify-content-between">
                        <span class="notification-title">7 اعلان جدید</span>
                        <span class="text-bold-400 cursor-pointer">
                          علامت خوانده شده به همه
                        </span>
                      </div>
                    </li>
                    <li class="scrollable-container media-list">
                      <a
                        class="d-flex justify-content-between"
                        href="javascript:void(0)"
                      >
                        <div class="media d-flex align-items-center">
                          <div class="media-left pr-0">
                            <div class="avatar mr-1 m-0">
                              <img
                                src="../../logo.png"
                                alt="avatar"
                                height="39"
                                width="39"
                              />
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">
                                تبریک بابت دریافت جوایز
                              </span>{" "}
                              در مسابقات سالانه
                            </h6>
                            <small class="notification-text">
                              15 اردیبهشت 12:32 ب.ظ
                            </small>
                          </div>
                        </div>
                      </a>
                      <div class="d-flex justify-content-between read-notification cursor-pointer">
                        <div class="media d-flex align-items-center">
                          <div class="media-left pr-0">
                            <div class="avatar mr-1 m-0">
                              <img
                                src="../../assets/images/portrait/small/avatar-s-16.jpg"
                                alt="avatar"
                                height="39"
                                width="39"
                              />
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">پیام جدید</span>{" "}
                              دریافت شد
                            </h6>
                            <small class="notification-text">
                              شما 18 پیام خوانده نشده دارید
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between cursor-pointer">
                        <div class="media d-flex align-items-center py-0">
                          <div class="media-left pr-0">
                            <img
                              class="mr-1"
                              src="../../assets/images/icon/sketch-mac-icon.png"
                              alt="avatar"
                              height="39"
                              width="39"
                            />
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">
                                به روز رسانی آماده است
                              </span>
                            </h6>
                            <small class="notification-text">
                              لورم ایپسوم متن ساختگی با تولید سادگی
                            </small>
                          </div>
                          <div class="media-right pl-0">
                            <div class="row border-left text-center">
                              <div class="col-12 px-50 py-50 border-bottom">
                                <h6 class="media-heading text-bold-500 mb-0">
                                  به‌روزرسانی
                                </h6>
                              </div>
                              <div class="col-12 px-50 py-50">
                                <h6 class="media-heading mb-0">بستن</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between cursor-pointer">
                        <div class="media d-flex align-items-center">
                          <div class="media-left pr-0">
                            <div class="avatar bg-primary bg-lighten-5 mr-1 m-0 p-25">
                              <span class="avatar-content text-primary font-medium-2">
                                ل‌د
                              </span>
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">مشتری جدید</span> ثبت
                              نام کرد
                            </h6>
                            <small class="notification-text">1 ساعت پیش</small>
                          </div>
                        </div>
                      </div>
                      <div class="cursor-pointer">
                        <div class="media d-flex align-items-center justify-content-between">
                          <div class="media-left pr-0">
                            <div class="media-body">
                              <h6 class="media-heading">پیشنهاد های جدید</h6>
                            </div>
                          </div>
                          <div class="media-right">
                            <div class="custom-control custom-switch">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                checked
                                id="notificationSwtich"
                              />
                              <label
                                class="custom-control-label"
                                for="notificationSwtich"
                              ></label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between cursor-pointer">
                        <div class="media d-flex align-items-center">
                          <div class="media-left pr-0">
                            <div class="avatar bg-danger bg-lighten-5 mr-1 m-0 p-25">
                              <span class="avatar-content">
                                <i class="bx bxs-heart text-danger"></i>
                              </span>
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">نرم افزار</span> تایید
                              شد
                            </h6>
                            <small class="notification-text">6 ساعت پیش</small>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between read-notification cursor-pointer">
                        <div class="media d-flex align-items-center">
                          <div class="media-left pr-0">
                            <div class="avatar mr-1 m-0">
                              <img
                                src="../../assets/images/portrait/small/avatar-s-4.jpg"
                                alt="avatar"
                                height="39"
                                width="39"
                              />
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">فایل جدید</span> ارسال
                              شد
                            </h6>
                            <small class="notification-text">4 ساعت پیش</small>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between cursor-pointer">
                        <div class="media d-flex align-items-center">
                          <div class="media-left pr-0">
                            <div class="avatar bg-rgba-danger m-0 mr-1 p-25">
                              <div class="avatar-content">
                                <i class="bx bx-detail text-danger"></i>
                              </div>
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">گزارش بودجه</span>{" "}
                              ایجاد شد
                            </h6>
                            <small class="notification-text">25 ساعت پیش</small>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between cursor-pointer">
                        <div class="media d-flex align-items-center border-0">
                          <div class="media-left pr-0">
                            <div class="avatar mr-1 m-0">
                              <img
                                src="../../assets/images/portrait/small/avatar-s-16.jpg"
                                alt="avatar"
                                height="39"
                                width="39"
                              />
                            </div>
                          </div>
                          <div class="media-body">
                            <h6 class="media-heading">
                              <span class="text-bold-500">مشتری جدید</span>{" "}
                              دیدگاهی ارسال کرد
                            </h6>
                            <small class="notification-text">2 روز پیش</small>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="dropdown-menu-footer">
                      <a
                        class="dropdown-item p-50 text-primary justify-content-center"
                        href="javascript:void(0)"
                      >
                        خواندن همه اعلان ها
                      </a>
                    </li>
                  </ul>
                </li> */}
                                <li class="dropdown dropdown-user nav-item">
                                    <a
                                        class="dropdown-toggle nav-link dropdown-user-link"
                                        href="#"
                                        data-toggle="dropdown"
                                    >
                                        <div class="user-nav d-sm-flex d-none">
                                            <span class="user-name">ادمین</span>
                                            <span class="user-status text-muted">HanafiCars</span>
                                        </div>
                                        <span>
                      <img
                          class="round"
                          src="../../assets/images/portrait/small/avatar-s-11.jpg"
                          alt="avatar"
                          height="40"
                          width="40"
                      />
                    </span>
                                    </a>
                                    <div class="dropdown-menu pb-0">
                                        {/* <a class="dropdown-item" href="page-user-profile.html">
                      <i class="bx bx-user mr-50"></i> ویرایش پروفایل
                    </a>
                    <a class="dropdown-item" href="app-email.html">
                      <i class="bx bx-envelope mr-50"></i> صندوق ورودی من
                    </a>
                    <a class="dropdown-item" href="app-todo.html">
                      <i class="bx bx-check-square mr-50"></i> وظیفه
                    </a>
                    <a class="dropdown-item" href="app-chat.html">
                      <i class="bx bx-message mr-50"></i> گفتگو ها
                    </a> */}
                                        <div class="dropdown-divider mb-0"></div>
                                        <a class="dropdown-item" href="auth-login.html">
                                            <i class="bx bx-power-off mr-50"></i> خروج
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
            {/* <!-- END: Header--> */}

            {/* <!-- BEGIN: Main Menu--> */}
            <div
                class="main-menu menu-fixed menu-light menu-accordion menu-shadow"
                data-scroll-to-active="true"
            >
                <div class="navbar-header">
                    <ul class="nav navbar-nav flex-row">
                        <li class="nav-item mr-auto">
                            <Link class="navbar-brand" to="/dashboard">
                                <div class="brand-logo">
                                    {/*<img class="logo" src="/logo.png" />*/}
                                </div>
                                <h2 class="brand-text mb-0">HanafiCars</h2>
                            </Link>
                        </li>
                        <li class="nav-item nav-toggle">
                            <a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse">
                                <i class="bx bx-x d-block d-xl-none font-medium-4 primary"></i>
                                <i
                                    class="toggle-icon bx bx-disc font-medium-4 d-none d-xl-block primary"
                                    data-ticon="bx-disc"
                                ></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="shadow-bottom"></div>
                <div class="main-menu-content">
                    <ul
                        class="navigation navigation-main"
                        id="main-menu-navigation"
                        data-menu="menu-navigation"
                        data-icon-style="lines"
                    >
                        <li class={` nav-item ${isDashboardActive ? "active-menu-item" : ""}`} style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  داشبورد
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      داشبورد اصلی
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class={` nav-item ${isAnalyticsActive ? "active-menu-item" : ""}`} style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                            : "none",
                        }}>
                            <Link to="/dashboard/analytics">
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Analytics">
                  آنالیتیکس سایت
                </span>
                            </Link>
                        </li>
                        <li class=" nav-item"
                            style={{
                                display:
                                    user?.roll === "admin" || user?.roll === "technical_manager"
                                        ? "block"
                                        : "none",
                            }}
                        >
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  محصولات
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/addProduct">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/showProducts">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class=" nav-item"
                            style={{
                                display:
                                    user?.roll === "admin" || user?.roll === "technical_manager"
                                        ? "block"
                                        : "none",
                            }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  لایو
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/editLive">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      لایو
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <Link to="/dashboard/homepageFeatured">
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  صفحه اصلی
                </span>
                            </Link>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  اطلاعیه ها{" "}
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/addNotification">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/notifications">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Register">
                      همه
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  پیشنهاد شگفت انگیز
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/addSpecialOffer">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/specialOffers">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Register">
                      همه
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  تالار گفت و گو
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/showForumCategories">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      دسته بندی ها
                    </span>
                                    </Link>
                                </li>

                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  نظرات
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/showComments">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      همه نظرات
                    </span>
                                    </Link>
                                </li>

                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  تماس با ما
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getContactUS">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      تماس با ما
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/getLeads">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Leads">
                      لیدهای فرم رایگان
                    </span>
                                    </Link>
                                </li>
                                <li><Link to="/dashboard/consultationLeads"><i class="bx bx-left-arrow-alt"></i><span class="menu-item">درخواست‌های مشاوره رایگان</span></Link></li>

                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>

                        <li
                            className=" nav-item"
                            style={{
                                display: user?.roll === "admin" ? "block" : "none",
                            }}
                        >
                            <a>
                                <i className="menu-livicon" data-icon="thumbnails-big"></i>
                                <span className="menu-title" data-i18n="Authentication">
                  بلاگ
                </span>
                            </a>
                            <ul className="menu-content">
                                <li>
                                    <Link to="/dashboard/AddBlogPost">
                                        <i className="bx bx-left-arrow-alt"></i>
                                        <span className="menu-item" data-i18n="Login">
                      افزودن پست
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/getBlogPosts">
                                        <i className="bx bx-left-arrow-alt"></i>
                                        <span className="menu-item" data-i18n="Login">
                      همه پست‌ها
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/blogCategories">
                                        <i className="bx bx-left-arrow-alt"></i>
                                        <span className="menu-item" data-i18n="Login">
                      دسته‌بندی‌ها
                    </span>
                                    </Link>
                                </li>

                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>

                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  تراکنش ها
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getPayments">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      همه تراکنش ها
                    </span>
                                    </Link>
                                </li>
                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  پشتیبانی ها
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getSupportPayments">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      پشتیبانی ها
                    </span>
                                    </Link>
                                </li>
                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager" || user?.roll === "support"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  محصولات کاربران
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getUserProducts">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      محصولات کاربران
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"
                            style={{
                                display:
                                    user?.roll === "admin" || user?.roll === "technical_manager"
                                        ? "block"
                                        : "none",
                            }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  کد های تخفیف
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getDiscountCodes">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item">مدیریت کدهای تخفیف</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/addDiscountCode">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      افزودن کد تخفیف
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager" || user?.roll === "support"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  کاربران
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getUsers">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      مدیریت کاربران
                    </span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  مدیریت کاربران داشبورد
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/getAdminUsers">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      مدیریت کاربران داشبورد
                    </span>
                                    </Link>
                                </li>

                                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
                            </ul>
                        </li>
                        <li class=" nav-item" style={{
                            display:
                                user?.roll === "admin" || user?.roll === "technical_manager"
                                    ? "block"
                                    : "none",
                        }}>
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  تنظیمات
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/updateInformation">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item" data-i18n="Login">
                      اطلاعات کلی
                    </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/siteSections">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item">مدیریت بخش‌های سایت</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/dashboard/menu">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item">منو ها</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li class=" nav-item">
                            <a>
                                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                                <span class="menu-title" data-i18n="Authentication">
                  ویرایش پروفایل
                </span>
                            </a>
                            <ul class="menu-content">
                                <li>
                                    <Link to="/dashboard/editProfile">
                                        <i class="bx bx-left-arrow-alt"></i>
                                        <span class="menu-item">ویرایش پروفایل</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            {/* <!-- END: Main Menu--> */}
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper">
                    <div class="content-header row"></div>
                    <div class="content-body">
                        <Switch>
                            <PrivateRoute path="/dashboard" component={PrivateRoutes}/>
                            {/* <Route path="/signin" component={addStore(SignIn)} /> */}
                            <Route path="*">
                                <Redirect to="/signIn"/>
                            </Route>
                        </Switch>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Screens;
